export * from './removed-zeit-art/removed-zeit-art.event.interface';
export * from './removed-zeit-unterart/removed-zeit-unterart.event.interface';
export * from './written-zeit-art/written-zeit-art.event.interface';
export * from './written-zeit-unterart/written-zeit-unterart.event.interface';
export * from './zeit-entfernt';
export * from './zeit-gespeichert';
